module.exports = __webpack_public_path__ + "static/media/avatar8.249373e7.png";